const en = {
    account: {
        addToLibraryError: 'Could not add walk to library.',
        cancelEditName: 'Cancel',
        defaultUser: 'User',
        discoverWalks: 'Discover walks',
        editNameButton: 'Edit',
        emptyLibrary: "You don't have any walks in your library yet.",
        library: 'My Library',
        loggingOut: 'Signing out...',
        logout: 'Sign out',
        namePlaceholder: 'Name',
        nameRequired: 'Name is required.',
        nameUpdateError: 'Could not save name. Please try again.',
        removeFromLibraryError: 'Could not remove walk from library.',
        saveNameButton: 'Save',
        savingName: 'Saving …',
        statusFinished: 'Finished',
        statusInProgress: 'In Progress',
        statusNotStarted: 'Not Started',
        title: 'My Account'
    },
    audioHighlightedText: {musicNoteIconLabel: 'Audio icon'},
    blog: {
        metaDescription: 'Stories, tips, and news about little walks and your city.',
        title: 'Blog'
    },
    changePassword: {
        confirmPlaceholder: 'Repeat new password',
        currentPlaceholder: 'Current password',
        error: 'Something went wrong. Please try again.',
        mismatch: 'The new passwords don\u2019t match.',
        newPlaceholder: 'New password',
        submit: 'Change password',
        submitting: 'Saving \u2026',
        success: 'Your password has been changed successfully.',
        title: 'Change password',
        tooShort: 'The new password must be at least 8 characters long.',
        wrongCurrent: 'Your current password is incorrect.'
    },
    checkout: {
        agb: 'I expressly consent to little walks beginning the provision of digital content before the '
            + 'expiry of the cancellation period. I am aware that I thereby lose my '
            + '<0>right of withdrawal</0>.',
        cancelledMessage: 'Purchase cancelled. You can try again anytime.',
        couponError: 'Could not verify coupon.',
        couponInvalid: 'Invalid coupon code.',
        error: 'An error occurred during checkout.',
        pendingMessage: 'Thank you! Your payment is still being processed. The walk will be unlocked once '
            + 'payment is confirmed.',
        successMessage: 'Purchase successful! The walk has been added to your library.'
    },
    common: {
        back: 'Back',
        currentStopLink: 'Go to current stop',
        free: 'Free',
        installApp: 'Install little walks as an app for faster access',
        installNow: 'Install',
        km: 'km',
        loading: 'Loading...',
        logoHomeLink: 'little walks – Home',
        meters: 'm',
        minutes: 'min',
        moreOptions: 'More options',
        nextStop: 'Next stop',
        notNow: 'Not now',
        pause: 'Pause',
        play: 'Play',
        previousStop: 'Previous stop',
        starRating: '{{star}} of 5 stars',
        updateAvailable: 'A new version is available',
        updateNow: 'Update now'
    },
    download: {
        downloadForOffline: 'Download for Offline',
        downloadingAudio: 'Downloading audio...',
        downloadingImages: 'Downloading images...',
        downloadingMap: 'Downloading map...',
        error: 'Download failed',
        offlineReady: 'Offline Ready',
        preparingDownload: 'Preparing download...',
        removeDownload: 'Remove Download',
        removing: 'Removing...',
        retry: 'Retry',
        storedOnDevice: 'Stored on device',
        updateAvailable: 'Update available',
        updateNow: 'Update now',
        updating: 'Updating...'
    },
    forgotPassword: {
        backToLogin: 'Back to sign in',
        description: 'Enter your email address and we\u2019ll send you a link to reset your password.',
        emailPlaceholder: 'Email address',
        error: 'Something went wrong. Please try again.',
        sending: 'Sending \u2026',
        submit: 'Send link',
        success: 'If an account with this email exists, we\u2019ve sent you a reset link. Please check your inbox.',
        title: 'Forgot password'
    },
    group: {
        backToHome: 'Back to home',
        connected: 'Connected',
        connectionConnected: 'Group connected',
        connectionReconnecting: 'Reconnecting …',
        consentLabel: 'I accept the privacy policy and agree that a cookie will be set for this session.',
        consentRequired: 'Please accept the privacy policy.',
        copiedMessage: 'Link copied!',
        copyLinkButton: 'Copy link',
        createButton: 'Create listening group',
        creating: 'Creating …',
        disconnected: 'Disconnected',
        endButton: 'End group',
        endedMessage: 'This group has ended.',
        enterCodePlaceholder: 'Group code',
        enterCodeRequired: 'Please enter a code.',
        enterCodeSubmit: 'Continue',
        joinCodeExpired: 'This code is no longer valid. Please scan again.',
        joinCodeLabel: 'Or enter this code:',
        joinGenericError: 'Something went wrong. Please try again.',
        joinLinkLabel: 'Or share this link:',
        joinNamePlaceholder: 'Your name',
        joinNameRequired: 'Name is required.',
        joinSubmit: 'Join',
        joinTitle: 'Join listening group',
        kickedMessage: 'You have been removed from the group.',
        leaderDisconnected: 'Connection to the guide lost. Waiting for them to return …',
        membersConnected: '{{count}} people connected',
        membersTitle: 'Connected members',
        noMembers: 'No members connected yet.',
        removeMember: 'Remove',
        resumePlaybackButton: 'Resume playback',
        rotateCodeButton: 'Generate new code',
        shareButton: 'Share',
        title: 'Group listening',
        waitingForLeader: 'Waiting for the guide …'
    },
    guide: {
        bio: 'Biography',
        email: 'Email',
        personalTour: 'Personal tour',
        personalTourAvailable: 'Personal tours available for booking',
        phone: 'Phone',
        price: 'Price',
        website: 'Website'
    },
    home: {
        allCities: 'All cities',
        categoryDiscovery: 'Discovery',
        categoryHistorical: 'Historical',
        categoryNature: 'Nature',
        categoryScenic: 'Scenic',
        filterFree: 'Free',
        filterPaid: 'Paid',
        filterShort: 'Short (under 1h)',
        noResults: 'No walks found.',
        searchPlaceholder: 'Search walks...',
        title: 'little walks'
    },
    karte: {
        allCategories: 'All',
        metaDescription: 'Discover all little walks on the map and find walks near you.',
        title: 'Map'
    },
    languagePopup: {
        confirm: 'Continue',
        subtitle: 'Choose your preferred language.',
        title: 'Welcome to little walks'
    },
    login: {
        email: 'Email',
        error: 'Login failed.',
        forgotPassword: 'Reset password',
        noAccount: "Don't have an account?",
        noPassword: 'Lost your password?',
        password: 'Password',
        register: 'Sign up',
        submit: 'Sign in',
        submitting: 'Signing in...',
        title: 'Sign in'
    },
    nav: {
        account: 'Account',
        faq: 'FAQ',
        home: 'Home',
        library: 'Library',
        login: 'Sign in',
        map: 'Map',
        settings: 'Settings'
    },
    nearbyWaypoints: {
        distanceLabel: '{{distance}} away',
        heading: 'Starting points near you',
        loadMore: 'Load more',
        modeAll: 'All stops'
    },
    notFound: {
        backToHome: 'Back to home',
        subtitle: "This path doesn't exist. Just start again from the home page.",
        title: 'Page not found'
    },
    offline: {
        cachedWalks: 'Downloaded Walks',
        empty: "You haven't downloaded any walks yet. Download walks to use them offline.",
        openWalk: 'Open walk',
        subtitle: 'You can still listen to your downloaded walks.',
        title: "You're offline"
    },
    protectedWalk: {
        backToLibrary: 'Back to library',
        guide: 'Guide:',
        map: 'Map',
        mapPlaceholder: 'Map view (coming soon)',
        openWaypoint: 'Open stop',
        waypoints: 'Stops'
    },
    purchases: {
        couponIconLabel: 'Coupon',
        empty: "You haven't made any purchases yet.",
        status: {
            completed: 'Completed',
            pending: 'Pending',
            refunded: 'Refunded'
        },
        title: 'My Purchases',
        unknownWalk: 'Unknown Walk'
    },
    register: {
        email: 'Email',
        error: 'Registration failed.',
        hasAccount: 'Already have an account?',
        login: 'Sign in',
        name: 'Name',
        newsletter: 'I would like to receive the newsletter (optional).',
        password: 'Password',
        privacy: 'I have read and accept the <0>Privacy Policy</0>.',
        submit: 'Create account',
        submitting: 'Creating...',
        title: 'Sign up'
    },
    resetPassword: {
        confirmPlaceholder: 'Repeat password',
        description: 'Choose a new password for your account.',
        error: 'This link is invalid or has expired. Please request a new one.',
        invalidToken: 'This link is invalid or incomplete. Please request a new one.',
        mismatch: 'The passwords don\u2019t match.',
        passwordPlaceholder: 'New password',
        submit: 'Save password',
        submitting: 'Saving \u2026',
        success: 'Your password has been changed successfully. You can now sign in.',
        title: 'Reset password',
        tooShort: 'The password must be at least 8 characters long.'
    },
    settings: {
        account: 'Account',
        analyticsLinkingDescription: 'Links your website usage to your account so we can analyze '
            + 'returning-user behavior in our analytics software.',
        analyticsLinkingDisabled: 'Off',
        analyticsLinkingEnabled: 'On',
        analyticsLinkingError: 'Could not save this setting. Please try again.',
        analyticsLinkingLogoutHint: 'Turning this off logs you out automatically, so the current session '
            + 'doesn\'t stay linked to your account.',
        imprint: 'Imprint',
        language: 'Language',
        languageDe: 'Deutsch',
        languageEn: 'English',
        legal: 'Legal',
        location: 'Location',
        locationDenied: 'Location access blocked by the browser. Please allow it in your browser settings.',
        locationDescription: 'Shows your position on the map so you can find stops more easily.',
        locationDisabled: 'Off',
        locationEnabled: 'On',
        privacy: 'Privacy Policy',
        title: 'Settings'
    },
    tourComplete: {
        ctaLabel: 'Finish Tour & Save to Journal',
        feedbackLabel: 'Share your thoughts',
        feedbackPlaceholder: 'What did you discover today?',
        finalStopReached: 'Final Stop Reached',
        rateJourney: 'Rate this Journey',
        shareJourney: 'Share Journey with Friends',
        subtitle: "You've completed all {{count}} stops.",
        title: 'A Beautiful Journey'
    },
    tourOverview: {
        active: 'ACTIVE',
        completed: 'COMPLETED',
        currentJourney: 'CURRENT JOURNEY',
        currentStop: 'Current Stop',
        expandMap: 'Expand Map',
        expeditionPath: 'The little walk',
        itinerary: 'Tour Itinerary',
        nowPlaying: 'Now Playing',
        pending: 'AVAILABLE',
        showMore: 'Show {{count}} More Stops'
    },
    verify: {
        checkEmail: 'Please check your inbox and click the confirmation link.',
        checkEmailTitle: 'Verify your email',
        error: 'Verification failed. The link may have expired.',
        login: 'Go to login',
        success: 'Your email has been verified. You can now sign in.',
        title: 'Email verification',
        verifying: 'Verifying...'
    },
    walkDetail: {
        adding: 'Adding...',
        addToLibrary: 'Add to library',
        buy: 'Buy',
        buyComingSoon: 'Buy (coming soon)',
        categories: 'Categories',
        details: 'Details',
        distance: 'Distance',
        duration: 'Duration',
        guide: 'Guide',
        inLibrary: 'In your library —',
        map: 'Map',
        mapPlaceholder: 'Map view (coming soon)',
        moreLockedLocations: 'more locations',
        open: 'Open',
        reviews: 'Reviews',
        season: 'Season',
        suitableFor: 'Suitable for',
        suitableForChildren: 'Children',
        suitableForDogs: 'Dogs',
        suitableForFamilies: 'Families',
        suitableForSeniors: 'Seniors',
        suitableForStroller: 'Stroller-friendly',
        suitableForWheelchair: 'Wheelchair-accessible',
        terrain: 'Terrain',
        terrainAsphalt: 'Asphalt',
        terrainCobblestone: 'Cobblestone',
        terrainForestPath: 'Forest path',
        terrainGravel: 'Gravel',
        terrainMixed: 'Mixed',
        waypoints: 'Stops',
        website: 'Website'
    },
    walkMap: {
        close: 'Close',
        detailsLink: 'View details',
        fountainLabel: 'Drinking fointain: {{name}}',
        fountainsHide: 'Hide drinking fountains',
        fountainsShow: 'Show drinking fountains',
        fullscreenEnter: 'Show fullscreen',
        fullscreenExit: 'Exit fullscreen',
        fullscreenHintButton: 'Open fullscreen',
        loading: 'Loading map…',
        locateMe: 'Show my location',
        twoFingerHint: 'Use two fingers to move the map. In fullscreen mode, one finger is enough.'
    },
    walks: {
        allCities: 'All cities',
        metaDescription: 'Discover all little walks – guided audio walking tours in your city.',
        noResults: 'No walks found.',
        searchPlaceholder: 'Search walks...',
        title: 'All Walks'
    },
    waypoint: {
        categoryLabel: 'Stop {{number}}',
        chapter: 'Chapter',
        explored: 'explored',
        nextWaypoint: 'Next Stop',
        storyTranscript: 'Story Transcript',
        upNext: 'Up Next',
        upNextComplete: 'Complete Tour',
        walkTime: '{{min}} min walk'
    }
};

export default en;